import type { MaskitoOptions } from "@maskito/core";
import {
  maskitoDateOptionsGenerator,
  maskitoWithPlaceholder,
} from "@maskito/kit";
import { makeZeroShortcutPreprocessor } from "./makeZeroShortcutPreprocessor";
import { DateMode } from "../../types";

const datePlaceholderMask = ({
  mode,
  separator = "/",
  placeholder,
}: {
  mode: DateMode;
  separator?: string;
  placeholder: string;
}) => {
  const dateOptions = maskitoDateOptionsGenerator({
    mode,
    separator,
  });

  const { plugins, removePlaceholder, ...placeholderOptions } =
    maskitoWithPlaceholder(placeholder);

  const datePlaceholderMask = {
    ...dateOptions,
    plugins: plugins.concat(dateOptions.plugins || []),
    preprocessors: [
      ...placeholderOptions.preprocessors,
      ...dateOptions.preprocessors,
      makeZeroShortcutPreprocessor(mode, separator),
    ],
    postprocessors: [
      ...dateOptions.postprocessors,
      ...placeholderOptions.postprocessors,
    ],
  } satisfies Required<MaskitoOptions>;

  return { options: datePlaceholderMask, removePlaceholder };
};

export default datePlaceholderMask;
